// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","calendar-event__container":"calendar-event__container","calendar-event__title":"calendar-event__title","calendar-event__service-date":"calendar-event__service-date","calendar-event__event":"calendar-event__event","calendar-event__calendar-icon":"calendar-event__calendar-icon","year":"year","month":"month","day":"day"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/UpcomingServices/CalendarEvent/css/CalendarEvent.styl
// module id = 1543
// module chunks = 0